<p-toast
  styleClass="amc-toast"
  position="top-right"
  (onClose)="onPrimeToastClose($event)"
>
  <ng-template pTemplate="headless" let-message let-closeFn="closeFn">
    @if (message) {
      <div class="toast-card">
        <span class="toast-card__icon" [attr.data-severity]="message.severity">
          @switch (message.severity) {
            @case ('error') {
              <img src="assets/toast/icon-error.svg" alt="" width="16" height="16" />
            }
            @case ('warn') {
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path
                  d="M8 4.25V8.75"
                  stroke="white"
                  stroke-width="1.73333"
                  stroke-linecap="round"
                />
                <path
                  d="M8 11.5V11.51"
                  stroke="white"
                  stroke-width="2.2"
                  stroke-linecap="round"
                />
              </svg>
            }
            @case ('info') {
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path
                  d="M8 7.25V11.75"
                  stroke="white"
                  stroke-width="1.73333"
                  stroke-linecap="round"
                />
                <path
                  d="M8 4.5V4.51"
                  stroke="white"
                  stroke-width="2.2"
                  stroke-linecap="round"
                />
              </svg>
            }
            @default {
              <img src="assets/toast/icon-check.svg" alt="" width="16" height="16" />
            }
          }
        </span>
        <div class="toast-card__text">
          @if (message.summary) {
            <p class="toast-card__title" [attr.data-severity]="message.severity">{{ message.summary }}</p>
          }
          @if (message.detail) {
            <p class="toast-card__detail">{{ message.detail }}</p>
          }
        </div>
        <button type="button" class="toast-card__close" aria-label="Close" (click)="closeFn($event)">
          <img src="assets/toast/icon-close.svg" alt="" width="14" height="14" />
        </button>
      </div>
    }
  </ng-template>
</p-toast>
